'use client'

// src/Search2.tsx
import { createIcon } from "@chakra-ui/icon";
var Search2Icon = createIcon({
  d: "M23.414,20.591l-4.645-4.645a10.256,10.256,0,1,0-2.828,2.829l4.645,4.644a2.025,2.025,0,0,0,2.828,0A2,2,0,0,0,23.414,20.591ZM10.25,3.005A7.25,7.25,0,1,1,3,10.255,7.258,7.258,0,0,1,10.25,3.005Z",
  displayName: "Search2Icon"
});

export {
  Search2Icon
};
//# sourceMappingURL=chunk-PZLLQGKX.mjs.map